export { messages as deMessages } from './de';
export { messages as enMessages } from './en';
export { messages as esMessages } from './es';
export { messages as frMessages } from './fr';
export { messages as itMessages } from './it';
export { messages as ptMessages } from './pt';
export { messages as skMessages } from './sk';
